// Copyright The Perses Authors
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
// http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

import { PaletteMode, SimplePaletteColorOptions } from '@mui/material';
import { green } from './colors';

export const success = (mode: PaletteMode): SimplePaletteColorOptions => {
  return mode === 'light'
    ? {
        main: green[500],
        dark: green[700],
        light: green[50],
      }
    : {
        main: green[400],
        dark: green[800],
        light: green[300],
      };
};
